export abstract class Factory {
  public abstract start(): void;
  public abstract stop(): void;
}
